import React from 'react';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';

const chartTypesMap = new Map(
  [
    ['bar', Bar],
  ],
);

const Chart = ({
  type = 'bar',
  data,
  options,
  ...moreProps
}) => {
  const Node = chartTypesMap.get(type);

  return (
    <Node
      data={data}
      width={100}
      height={50}
      options={options}
      {...moreProps}
    />
  );
};

Chart.propTypes = {
  type: PropTypes.string.isRequired,
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string),
    datasets: PropTypes.arrayOf(PropTypes.shape({
      backgroundColor: PropTypes.string,
      borderColor: PropTypes.string,
      data: PropTypes.arrayOf(PropTypes.number),
      label: PropTypes.string,
    })),
  }).isRequired,
  options: PropTypes.shape({}).isRequired,
};

export default Chart;
